<template>
  <div class="animated fadeIn">
    <p class="h2">申し込み</p>
    </div>
</template>

<script>
export default {
  name: 'tables'
}

</script>



// WEBPACK FOOTER //
// src/views/home/RequestGrade.vue